import React, { Fragment } from "react";
import { View, StyleSheet, Text, Image, Pressable } from "react-native";
import { IChatConversationTypeModel } from "../../services/models/chat";
import { CloseIcon, FileIcon, PdfIcon, WordIcon } from "../Icons";

interface Props {
  uri: string;
  fileName?: string;
  onPressClose: () => void;
  type: IChatConversationTypeModel;
}

export default function PreViewBeforeSend({
  uri,
  type,
  fileName,
  onPressClose,
}: Props) {
  const render = () => {
    if (type === "image") {
      return (
        <Image
          source={{ uri: uri }}
          resizeMode="contain"
          style={{ width: 100, height: 100, marginHorizontal: "auto" }}
        />
      );
    }

    if (type === "file") {
      const ext = fileName?.split(".")[1];
      if (ext === "pdf") {
        return <PdfIcon size={55} />;
      }
      if (ext === "docx") {
        return <WordIcon size={55} />;
      }

      return <FileIcon size={55} />;
    }

    return <Fragment />;
  };

  return (
    <View style={type === "text" ? {} : styles.container}>
      {render()}
      {uri ? (
        <Fragment>
          <Text style={{ color: "#000"}}>{fileName}</Text>
          <Pressable onPress={onPressClose} style={styles.closeIcon}>
            <CloseIcon />
          </Pressable>
        </Fragment>
      ) : (
        <Fragment />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: "auto",
    // backgroundColor: "red",
    width: 100,
    height: 100,
    justifyContent: "center",
    alignItems: "center",
  },
  closeIcon: { position: "absolute", top: 10, right: 10 },
});
